(function () {
  'use strict';

  const BOT_MIN_DWELL_MS = 1500;

  const config = (window.theme && window.theme.quoteRequest) || null;
  if (!config || !config.webhookUrl) return;

  const strings = config.strings || {};

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const modal = document.querySelector('[data-quote-request-modal]');
    const triggers = document.querySelectorAll('.js-quote-request-open');
    if (!modal || triggers.length === 0) return;

    const form = modal.querySelector('[data-quote-request-form]');
    const formWrap = modal.querySelector('[data-quote-request-form-wrap]');
    const successBlock = modal.querySelector('[data-quote-request-success]');
    const submitBtn = modal.querySelector('[data-quote-request-submit]');
    const statusEl = modal.querySelector('[data-quote-request-status]');
    const backdrop = modal.querySelector('[data-quote-request-backdrop]');
    const closeBtns = modal.querySelectorAll('.js-quote-request-close');

    let openedAt = 0;
    let lastTrigger = null;

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        lastTrigger = evt.currentTarget;
        openModal();
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    backdrop.addEventListener('click', function (evt) {
      if (evt.target === backdrop) closeModal();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && modal.classList.contains('modal--is-active')) {
        closeModal();
      }
    });

    form.addEventListener('submit', onSubmit);

    function openModal() {
      resetToFormState();
      modal.classList.add('modal--is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('modal-open');
      document.body.classList.add('modal-open');
      openedAt = Date.now();
      const firstField = form.querySelector('input[name="firstname"]');
      if (firstField) {
        // small delay so transition doesn't fight focus
        setTimeout(function () { firstField.focus(); }, 50);
      }
    }

    function closeModal() {
      modal.classList.remove('modal--is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('modal-open');
      document.body.classList.remove('modal-open');
      if (lastTrigger) lastTrigger.focus();
    }

    function resetToFormState() {
      formWrap.hidden = false;
      successBlock.hidden = true;
      statusEl.textContent = '';
      statusEl.classList.remove('quote-request__status--error');
      submitBtn.disabled = false;
      submitBtn.classList.remove('btn--loading');
    }

    function showSuccess() {
      formWrap.hidden = true;
      successBlock.hidden = false;
      // Move focus into success block for AT users
      const closeBtnInSuccess = successBlock.querySelector('.js-quote-request-close');
      if (closeBtnInSuccess) closeBtnInSuccess.focus();
    }

    function showError(msg) {
      statusEl.textContent = msg || strings.error || 'Error';
      statusEl.classList.add('quote-request__status--error');
      submitBtn.disabled = false;
      submitBtn.classList.remove('btn--loading');
    }

    async function onSubmit(evt) {
      evt.preventDefault();

      // Native browser validation
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const fd = new FormData(form);
      const honeypotValue = (fd.get('website') || '').toString().trim();
      const dwellMs = Date.now() - openedAt;

      // Bot detection: honeypot filled OR submit-too-fast
      // Show success-state silently so the bot believes it worked, but skip the network call.
      if (honeypotValue !== '' || dwellMs < BOT_MIN_DWELL_MS) {
        showSuccess();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.classList.add('btn--loading');
      statusEl.textContent = '';
      statusEl.classList.remove('quote-request__status--error');

      let cart;
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('cart.js HTTP ' + res.status);
        cart = await res.json();
      } catch (err) {
        showError();
        return;
      }

      // Items: pass through 1:1 from /cart.js. Prices stay in cents
      // (cents -> euro conversion is the Zapier Code-Step's job, not the
      // theme's). Properties are forwarded as-is, including hidden
      // underscore-prefixed keys — the Code-Step filters them server-side
      // where the rule is centralized and robust.
      const items = (cart.items || []).map(function (item) {
        return {
          key: item.key,
          product_id: item.product_id,
          variant_id: item.variant_id,
          sku: item.sku,
          title: item.title,
          product_title: item.product_title,
          variant_title: item.variant_title,
          vendor: item.vendor,
          quantity: item.quantity,
          price: item.price,
          original_price: item.original_price,
          line_price: item.line_price,
          original_line_price: item.original_line_price,
          url: item.url,
          image: item.image,
          properties: item.properties || {}
        };
      });

      const shopDomain = (window.Shopify && window.Shopify.shop)
        ? window.Shopify.shop
        : location.hostname;

      const payload = {
        source: 'shopify_quote_request',
        submitted_at: new Date().toISOString(),
        customer: {
          first_name: (fd.get('firstname') || '').toString().trim(),
          last_name: (fd.get('lastname') || '').toString().trim(),
          email: (fd.get('email') || '').toString().trim(),
          phone: (fd.get('phone') || '').toString().trim(),
          company: (fd.get('company') || '').toString().trim(),
          vat_id: (fd.get('vat_id') || '').toString().trim(),
          message: (fd.get('message') || '').toString().trim(),
          privacy_consent: fd.get('privacy_consent') === 'on'
        },
        cart: {
          token: cart.token,
          note: cart.note || '',
          attributes: cart.attributes || {},
          currency: cart.currency,
          item_count: cart.item_count,
          total_price: cart.total_price,
          subtotal_price: cart.items_subtotal_price,
          original_total_price: cart.original_total_price,
          total_discount: cart.total_discount,
          items: items
        },
        shop: {
          domain: shopDomain,
          permalink: location.origin + '/cart'
        }
      };

      try {
        const res = await fetch(config.webhookUrl, {
          method: 'POST',
          // No custom headers → request stays a CORS-safelisted "simple request",
          // so Zapier doesn't need preflight handling.
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('webhook HTTP ' + res.status);

        if (window.dataLayer) {
          // GTM eCommerce convention expects values in major currency units,
          // so this is the one place we still divide cents by 100.
          window.dataLayer.push({
            event: 'quote_request_submitted',
            cart_value: payload.cart.total_price / 100,
            items_count: payload.cart.item_count,
            currency: payload.cart.currency
          });
        }

        showSuccess();
      } catch (err) {
        showError();
      }
    }
  }
})();
